<template>
  <div class="content">
    <!-- <div id="top">
      
   <header-box title='考试动态'></header-box>    
   
    </div> -->
    <!-- <div id="top">
      <span class="rightcha"
        ><img width="20px" src="../../assets/cha.png" />
        <span class="centerwz">考试动态</span></span
      >
    </div> -->
    <div class="boxpad">
      <div class="flexcontain">
        <div class="own_name">考生信息&nbsp;: &nbsp;</div>
     <input-box  class="own_input" v-model="ownnameinput" @bluript='searchblur' placeholder="可搜索姓名或手机号">
        </input-box>
        <!-- <input class="own_input" v-model="ownnameinput" placeholder="可搜索姓名或手机号"> -->
      </div>

      <div class="flexcontain" @click="select1click">
        <span class="own_name">工种：</span>
            <choose-box class="compomnet " :rtest='choosetype1'></choose-box>
 
      </div>
      <div class="flexcontain" @click="select2click">
        <span class="own_name">考试时间：</span>
        <choose-box class="compomnet" :rtest="choosetype2"></choose-box>
      </div>
      <div class="flexcontain" @click="select3click">
        <span class="own_name">预约时间：</span>
            <choose-box class="compomnet " :rtest='choosetype3'></choose-box>
 
      </div>

      <div class="flexcontain" @click="select4click">
        <span class="own_name">考试动态：</span>
            <choose-box class="compomnet " :rtest='choosetype4'></choose-box>
 
      </div>

      <table class="tablecontain">
        <thead>
          <tr class="tablehead">
            <th >序号</th>
            <th class="name">姓名</th>
            <th>手机号</th>
            <th>批次</th>
            <th>工种</th>
            <th>等级</th>
            <th class="sub">科目</th>
            <th>考试时间</th>
            <th class="test">考试动态</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tablebody" v-for="(item, index) in examarr" :key="index">
            <td>{{ item.serial }}</td>
            <td>{{ item.examName }}</td>
            <td>{{ item.examPhone }}</td>
            <td>{{ item.appraisalBatchName }}</td>
            <td>{{ item.examSubiectName }}</td>
            <td>{{ item.examRank}}</td>
            <td>{{ item.subject }}</td>
            <td>{{ item.examTime }}</td>
            <td>{{ item.examDynamicText }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!examarr.length" style="width:100%;margin-top:20px;text-align:center;color:grey">暂无数据</div>

    </div>
    <van-popup
      position="bottom"
      round
      :style="{ height: '50%' }"
      v-model="Place1Show"
    >
      <van-picker
        confirm-button-text="完成"
        cancel-button-text="科目"
        show-toolbar
        :columns="columnz1"
        @confirm="zConfirm1"
        @cancel="zCancel1"
        @change="zChange1"
      />
    </van-popup>
    <van-popup
      position="bottom"
      round
      :style="{ height: '50%' }"
      v-model="Place2Show"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="zConfirm2"
        @cancel="zCancel2"
        @change="zChange2"
        confirm-button-text="完成"
        cancel-button-text="考试日期"
        :formatter="formatter"
  
      />
    </van-popup>

    <van-popup
      position="bottom"
      round
      :style="{ height: '50%' }"
      v-model="Place3Show"
    >
      <van-picker
        confirm-button-text="完成"
        cancel-button-text="预约时间"
        show-toolbar
        :columns="columnz3"
        @confirm="zConfirm3"
        @cancel="zCancel3"
        @change="zChange3"
      />
    </van-popup>

    <van-popup
      position="bottom"
      round
      :style="{ height: '50%' }"
      v-model="Place4Show"
    >
      <van-picker
 
        show-toolbar
        :columns="columnz4"
        @confirm="zConfirm4"
        @cancel="zCancel4"
        @change="zChange4"
        confirm-button-text="完成"
        cancel-button-text="考试动态"

      />
    </van-popup>
	 
   
  </div>
</template>

<script>
import datetime from '../../utils/datetime.js'
import Select from '@/components/Select'
import inputBox from '@/components/input.vue'
import chooseBox from '@/components/choose'
import headerBox from '@/components/header.vue'
import {dynamicmoreinfo,showaddres,dynamicmoreiptS}  from  '../../api/apitotal.js'
export default {
  name: 'App_',

  data() {
    return {
      examarr: [],
      statusObj: {
        'normal': '考试中',
        'exception': '考试中',
        'miss': '未考试',
        'submitted': '已考试',
        'tookNumber': '已取号'
      },

Place1Show:false,
Place2Show:false,
Place3Show:false,
Place4Show:false,
 columnz4: ['全部','未开考', '未签到', '已取号', '考试中','已交卷','弃考'],
 columnz3: ['08:30-09:30', '09:30-10:30','10:30-11:00','11:30-12:30','14:00-15:00'],
 columnz2: ['已取ee号', '未开考', '未签到', '已交卷', '考试中'],
 columnz1: ['全部','理论', '实操'],
 ownnameinput:'',
 choosetype1:'可选择考试科目',
 choosetype2:'可选择日期',
 choosetype3:'可选择时间范围',
 choosetype4:'全部',
 chooseindex1:null,
 chooseindex2:null,
 chooseindex3:null,
 chooseindex4:null,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
    };
  },
  components: {
    Select,
    chooseBox,
    headerBox,
    inputBox
  },
  created(){
    this.getStudentList()
  },
  methods: {
    getStudentList: function() {  //查询列表
      let params = {
        keyword: '', //关键字
        occupation: '', //工种
        levelName: '',  //等级
        subject: '', //科目
        status: '', //动态 未开考 noTest 未签到 noNumber
        page: 1,
        limit: 36
      }
      this.$http.get('/registration/examiees/status', { params }).then(res => {
        let list = res.data.data || []
        if(res.data.success){
          list.forEach((element,index) => {
            element.serial = index + 1
            element.examDynamicText = this.statusObj[element.examDynamic]
          })
          this.examarr = list
        }
      })
    },



    //添加年月日字
   formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    searconfirm(){
      var inputdata=`keyword=${this.ownnameinput.length>0?this.ownnameinput:null}&subject=${typeof(this.chooseindex1)=='number'?this.chooseindex1+1:null}&examTime=${null}&examDynamic=${typeof(this.chooseindex4)=='number'?this.chooseindex4+1:null}`

            dynamicmoreiptS(`examDynamic/findExamDynamic`,inputdata,'post').then(res=>{
          console.log(res)
          if(res.data.success&&res.status==200){
       this.examarr=res.data.data.data
          }
    })
    },
    searchblur(){
  this.searconfirm()
    },
initdatatable(){
            dynamicmoreinfo(`registration/findAll`,null,'post').then(res=>{
          console.log(res)
          if(res.data.success&&res.status==200){
       this.examarr=res.data.data.list
        }
    })
    },


 select1click(){
this.Place1Show=true
    },

  select2click(){
this.Place2Show=true
    },
  select3click(){
this.Place3Show=true
    },
  select4click(){
this.Place4Show=true
    },
  zConfirm1(value, index){
   this.zCancel1() 
   this.choosetype1=value
   this.chooseindex1=index
    this.searconfirm()
    },
   zConfirm2(value, index){
    this.zCancel2() 
     this.choosetype2=datetime(value) 
      this.searconfirm()
  
    },
   zConfirm3(value, index){
    this.zCancel3() 
        this.choosetype3=value
   this.chooseindex3=index
    this.searconfirm()
      //  this.choosetype3=datetime(value)
      //    this.chooseindex3=index
    },
   zConfirm4(value, index){
    this.zCancel4() 
     this.choosetype4=value
   this.chooseindex4=index 
    this.searconfirm()
    },
  zCancel1(){
  this.Place1Show=false  
    },
   zCancel2(){
  this.Place2Show=false  
    },
   zCancel3(){
  this.Place3Show=false  
    },
   zCancel4(){
  this.Place4Show=false  
    },

 zChange4(picker, value, index){

 },
  zChange1(picker, value, index){

 },
  zChange2(picker, value, index){

 },
  zChange3(picker, value, index){

 },
  },
};
</script>

<style scoped lang="less">
.boxpad{
  padding: 0 @checkringht @checkringht @checkringht;
  background: @whitee;
}
#top {
  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}
.content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  /* padding-top: 60px;
  margin-left: 400px; */
  min-width: 1080px;
  height: 100vh;
  background-color: white;
}
.rightcha {
  float: left;
}
.rightcha img {
  vertical-align: middle;
}
.flexcontain{
  display: flex;
  margin-top: @checkringht;
  width: 100%;
  // height: 80px;
  justify-content: center;
  align-items: center;
    .own_name{
    color: @leftcolor;
    font-weight: 600;
    width: 160px;
  }
}
.own_input,.cat-choose{
  flex: 1;
  height: @minboxgao;
  line-height: @minboxgao;
}
.tablecontain{
  width: 100%;
  border-left: 1px solid @tableborder;
  border-top: 1px solid @tableborder;
  border-spacing: 0;
  margin-top: @minboxgao;
  .tablebody:nth-child(2n+2){
    background: @tablecolor;
  }
}
 .tablehead>th,.tablebody>td{
  border-right: 1px solid @tableborder;
  border-bottom: 1px solid @tableborder;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.tablebody>td {
  padding: 20px;
}
.tablebody>td>img{
  width: 30px;
  height: 15px;
  margin-left: 4px;
}
.tablehead{
  font-size: 24px;
}
.tablehead .sub{
  width: 95px;
  height: 50px;
}
.tablehead .test{
  width: 110px;
  height: 100px;
}
.tablehead .name {
  width: 96px;
}

</style>
